import { createContext, useContext, useState, useEffect } from 'react'

const LanguageContext = createContext()

const translations = {
  ar: {
    // Navigation
    home: 'الرئيسية',
    offers: 'العروض',
    gallery: 'المعرض',
    contact: 'تواصل معنا',
    admin: 'لوحة التحكم',
    
    // Hero
    heroTitle1: 'حول',
    heroTitle2: 'جسدك',
    heroTitle3: 'إلى',
    heroTitle4: 'آلة',
    heroSubtitle: 'انضم إلى نادي أوكسجين واكتشف عالماً من القوة واللياقة',
    startJourney: 'ابدأ رحلتك',
    watchVideo: 'شاهد الفيديو',
    activeMembers: 'عضو نشط',
    professionalTrainers: 'مدرب محترف',
    service24_7: 'خدمة 24/7',
    
    // Features
    features: 'مميزاتنا',
    modernEquipment: 'أحدث المعدات',
    expertTrainers: 'مدربون خبراء',
    flexibleTime: 'أوقات مرنة',
    specialOffers: 'عروض خاصة',
    
    // Offers
    choosePlan: 'اختر خطتك',
    flexibleSubscriptions: 'اشتراكات مرنة تناسب احتياجاتك',
    month: 'شهر',
    months: 'أشهر',
    year: 'سنة',
    syp: 'ل.س',
    subscribeNow: 'اشترك الآن',
    mostPopular: 'الأكثر طلباً',
    
    // Gallery
    viewFacilities: 'استعرض مرافقنا',
    gallerySubtitle: 'جولة داخل نادي أوكسجين',
    
    // Contact
    getInTouch: 'تواصل معنا',
    contactSubtitle: 'نحن هنا لمساعدتك في تحقيق أهدافك',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'رقم الجوال',
    message: 'الرسالة',
    send: 'إرسال',
    address: 'العنوان',
    workingHours: 'ساعات العمل',
    followUs: 'تابعنا',
    
    // Admin
    dashboard: 'لوحة التحكم',
    offersAndSubscriptions: 'العروض والاشتراكات',
    photoGallery: 'معرض الصور',
    promotions: 'العروض الترويجية',
    messages: 'الرسائل',
    siteSettings: 'إعدادات الموقع',
    logout: 'تسجيل الخروج',
    login: 'تسجيل الدخول',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    invalidCredentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
    addOffer: 'إضافة عرض',
    uploadImage: 'رفع صورة',
    addPromotion: 'إضافة عرض ترويجي',
    save: 'حفظ',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    active: 'نشط',
    inactive: 'معطل',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح',
    passwordsDontMatch: 'كلمتا المرور غير متطابقتين',
    landingPagePhotos: 'صور الصفحة الرئيسية',
    heroVideo: 'فيديو الصفحة الرئيسية',
    uploadVideo: 'رفع فيديو',
    uploadHeroImage: 'رفع صورة رئيسية',
    all: 'الكل',
    
    // Footer
    allRightsReserved: 'جميع الحقوق محفوظة',
  },
  en: {
    // Navigation
    home: 'Home',
    offers: 'Offers',
    gallery: 'Gallery',
    contact: 'Contact Us',
    admin: 'Admin Dashboard',
    
    // Hero
    heroTitle1: 'Transform',
    heroTitle2: 'Your Body',
    heroTitle3: 'Into A',
    heroTitle4: 'Machine',
    heroSubtitle: 'Join Oxygen Gym and discover a world of strength and fitness',
    startJourney: 'Start Your Journey',
    watchVideo: 'Watch Video',
    activeMembers: 'Active Members',
    professionalTrainers: 'Professional Trainers',
    service24_7: '24/7 Service',
    
    // Features
    features: 'Our Features',
    modernEquipment: 'Modern Equipment',
    expertTrainers: 'Expert Trainers',
    flexibleTime: 'Flexible Hours',
    specialOffers: 'Special Offers',
    
    // Offers
    choosePlan: 'Choose Your Plan',
    flexibleSubscriptions: 'Flexible subscriptions that fit your needs',
    month: 'Month',
    months: 'Months',
    year: 'Year',
    syp: 'SYP',
    subscribeNow: 'Subscribe Now',
    mostPopular: 'Most Popular',
    
    // Gallery
    viewFacilities: 'View Our Facilities',
    gallerySubtitle: 'A tour inside Oxygen Gym',
    
    // Contact
    getInTouch: 'Get In Touch',
    contactSubtitle: 'We are here to help you achieve your goals',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    send: 'Send',
    address: 'Address',
    workingHours: 'Working Hours',
    followUs: 'Follow Us',
    
    // Admin
    dashboard: 'Dashboard',
    offersAndSubscriptions: 'Offers & Subscriptions',
    photoGallery: 'Photo Gallery',
    promotions: 'Promotions',
    messages: 'Messages',
    siteSettings: 'Site Settings',
    logout: 'Logout',
    login: 'Login',
    username: 'Username',
    password: 'Password',
    invalidCredentials: 'Invalid username or password',
    addOffer: 'Add Offer',
    uploadImage: 'Upload Image',
    addPromotion: 'Add Promotion',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    active: 'Active',
    inactive: 'Inactive',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordChanged: 'Password changed successfully',
    passwordsDontMatch: 'Passwords do not match',
    landingPagePhotos: 'Landing Page Photos',
    heroVideo: 'Hero Video',
    uploadVideo: 'Upload Video',
    uploadHeroImage: 'Upload Hero Image',
    
    // Footer
    allRightsReserved: 'All Rights Reserved',
    all: 'All',
  }
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('oxygen_language')
    return saved || 'ar'
  })

  const currency = 'syp' // Always use Syrian Pound

  useEffect(() => {
    localStorage.setItem('oxygen_language', language)
    document.documentElement.lang = language
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr'
  }, [language])



  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ar' ? 'en' : 'ar')
  }

  const t = (key) => translations[language][key] || key

  const convertPrice = (price) => {
    const numPrice = parseFloat(price)
    if (isNaN(numPrice)) return price
    return numPrice.toFixed(0) // No conversion, just format as whole number for SYP
  }

  const getCurrencySymbol = (currencyType = currency) => {
    return translations[language][currencyType] || currencyType
  }

  return (
    <LanguageContext.Provider value={{ 
      language, 
      currency, 
      toggleLanguage, 
      t, 
      convertPrice, 
      getCurrencySymbol 
    }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  const context = useContext(LanguageContext)
  if (!context) throw new Error('useLanguage must be used within LanguageProvider')
  return context
}
